import React from 'react';
import { Card } from 'react-bootstrap';
import { processValue } from '../Utils/generalUtil';
import s from './SummaryTypeStyle1.module.scss';

const lightningBgStyle = {
  backgroundImage: 'url(`data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTAgNTAiIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+PHBhdGggZD0iTTMwIDggTDE4IDI4IEwyMiAyOCBMMjAgNDIgTDMyIDIyIEwyOCAyMiBMMzAgOCBaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPjwvc3ZnPg==`)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: '50px 50px',
  width: '100px !important', 
  height: '100px !important',
  backgroundColor: 'rgba(255, 255, 255, 0.1)' // Semi-transparent white background

}

const getIconSytle = (iconName) => {
    switch (iconName) {
        case 'LightningCharge':
            return lightningBgStyle;
        default:
            return {};
    }
}

const SummaryTypeStyle1 = ({ dashboardDetail, isLoading }) => {

    return (
        <Card className={`${s.cardStyle} ${isLoading ? s.lightGray : ''} shadow h-100`} style={getIconSytle(dashboardDetail.IconName)}>
            <Card.Body className="d-flex flex-column p-4">
                <div className="mb-0">
                    <div className="text-white opacity-100 mb-0 fw-normal" style={{ fontSize: '1rem' }}>
                        {dashboardDetail.Title}
                    </div>
                </div>
                <div className="mt-auto">
                    <div className="text-white mb-0  " style={{ fontSize: '3rem', fontWeight: '300'}}>
                        {processValue(dashboardDetail.EvaluatedValue)}
                    </div>

                </div>
                <div className="text-white opacity-100 mb-0 fw-normal" style={{ fontSize: '1rem' }}>
                    {dashboardDetail.UoM}
                </div>
            </Card.Body>
        </Card>
    );
};

export default SummaryTypeStyle1;